/* eslint-disable */
import $ from 'jquery';
import ko from 'knockout';
import sectionItemTemplate from '@bingads-webui-static-legacy/shared/template/SectionItem.pug';
ko.bindingHandlers.sectionItem = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    var bindingOptions = valueAccessor();
    var innerBindingContext = bindingContext.extend({
      bindingOptions: bindingOptions
    });
    var $element = $(element);
    var $newContent = $(sectionItemTemplate()).addClass($element.attr('class'));
    $element.children().detach().appendTo($newContent.find('.section-item-editor'));
    $(element).replaceWith($newContent);
    ko.applyBindingsToDescendants(innerBindingContext, $newContent[0]);
    return {
      controlsDescendantBindings: true
    };
  }
};

